export default __webpack_public_path__ + "static/media/Gallery-20.4ba3abbc.jpeg";